import type {
  Form1099PrepSummary,
  ScheduleCSummary,
  TaxFilingDraftSummary,
  TaxDeadline,
} from '@eriko/shared-types';
import { apiClient } from '../lib/api';

export async function get1099Prep(
  orgId: string,
  taxYear: number,
): Promise<Form1099PrepSummary> {
  const { data } = await apiClient.get('/tax/1099-prep', {
    params: { orgId, taxYear },
  });
  return data;
}

export async function getScheduleCSummary(
  orgId: string,
  taxYear: number,
): Promise<ScheduleCSummary> {
  const { data } = await apiClient.get('/tax/schedule-c-summary', {
    params: { orgId, taxYear },
  });
  return data;
}

export async function getFilingDrafts(
  orgId: string,
): Promise<TaxFilingDraftSummary[]> {
  const { data } = await apiClient.get('/tax/filing-drafts', {
    params: { orgId },
  });
  return data;
}

export async function getTaxDeadlines(
  orgId: string,
): Promise<TaxDeadline[]> {
  const { data } = await apiClient.get('/tax/deadlines', {
    params: { orgId },
  });
  return data;
}

export async function markDraftFiled(
  orgId: string,
  draftId: string,
  body: { filedVia: 'qbo' | 'manual'; filedDate?: string; evidence?: string },
): Promise<TaxFilingDraftSummary> {
  const { data } = await apiClient.post(
    `/tax/filing-drafts/${draftId}/mark-filed`,
    body,
    { params: { orgId } },
  );
  return data;
}
